// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__hq1mv","validationTips":"StatementDescriptor_validationTips__13wz4"};